module.exports = __webpack_public_path__ + "img/26.11f9f82c.jpg";